// // import React, { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import Api from "../Utills/Api";
// // import { motion, AnimatePresence } from "framer-motion";
// // import logo from "../../Frozenwala.png";

// // const OrderHistory = () => {
// //   const navigate = useNavigate();
// //   const [historyData, setHistoryData] = useState([]);

// //   const getHistory = async () => {
// //     try {
// //       const uid = localStorage.getItem("user_id");
// //       const response = await Api.get(`api/orders/?user_id=${uid}`);
// //       console.log("response from order history: ",response.data)
// //       setHistoryData(response.data);
// //     } catch (error) {
// //       console.log("Error fetching history:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     getHistory();
// //   }, []);

// //   const handleButton = (order) => {
// //     const { order_id } = order;
// //     navigate(`/orderdetails/${order_id}/`);
// //   };

// //   const getStatusDetails = (status) => {
// //     switch (status) {
// //       case "1":
// //         return { text: "Pending", color: "#e41f26" };
// //       case "2":
// //         return { text: "Confirm", color: "#03A9F4" };
// //       case "3":
// //         return { text: "Picked Up", color: "#4CAF50" };
// //       case "4":
// //         return { text: "Delivered", color: "#8BC34A" };
// //       case "5":
// //         return { text: "Cancel", color: "#5dc5fa" };
// //       case "6":
// //         return { text: "Return Request", color: "#9E9E9E" };
// //       default:
// //         return { text: "Accepted", color: "#9C27B0" };
// //     }
// //   };

// //   return (
// //     <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh", padding: "20px" }}>
// //       <div
// //         style={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           flexWrap: "wrap",
// //           marginBottom: "20px",
// //         }}
// //       >
// //         {/* <button
// //           onClick={() => navigate(-1)}
// //           style={{
// //             backgroundColor: "#fff",
// //             borderRadius: "10px",
// //             border: "1px solid #e41f26",
// //             padding: "8px 16px",
// //             cursor: "pointer",
// //             fontWeight: "bold",
// //           }}
// //         >
// //           👈 Go Back
// //         </button> */}
// //         <h1 style={{ flex: 1, textAlign: "center", fontSize: "1.5rem", margin: "10px 0" }}>
// //           Order History
// //         </h1>
// //         <div style={{ width: "100px" }}></div>
// //       </div>

// //       {historyData.length === 0 ? (
// //         <div
// //           style={{
// //             textAlign: "center",
// //             marginTop: "50px",
// //             fontSize: "1.2rem",
// //             color: "#888",
// //           }}
// //         >
// //           No history available
// //         </div>
// //       ) : (
// //         <div
// //           style={{
// //             display: "flex",
// //             flexDirection: "column",
// //             gap: "15px",
// //             maxWidth: "800px",
// //             margin: "0 auto",
// //           }}
// //         >
// //           <AnimatePresence>
// //             {historyData.map((order) => {
// //               const { text: statusText, color } = getStatusDetails(order.status);

// //               return (
// //                 <motion.div
// //                   key={order.id}
// //                   initial={{ opacity: 0, y: 20 }}
// //                   animate={{ opacity: 1, y: 0 }}
// //                   exit={{ opacity: 0, y: -20 }}
// //                   whileHover={{ scale: 1.02, boxShadow: "0 8px 20px rgba(0,0,0,0.2)" }}
// //                   transition={{ duration: 0.3 }}
// //                   onClick={() => handleButton(order)}
// //                   style={{
// //                     backgroundColor: "#fff",
// //                     borderRadius: "12px",
// //                     padding: "15px",
// //                     display: "flex",
// //                     flexWrap: "wrap",
// //                     alignItems: "center",
// //                     cursor: "pointer",
// //                   }}
// //                 >
// //                   <img
// //                     src={logo}
// //                     alt="logo"
// //                     style={{
// //                       width: "80px",
// //                       height: "80px",
// //                       borderRadius: "12px",
// //                       objectFit: "contain",
// //                       marginRight: "15px",
// //                       flexShrink: 0,
// //                     }}
// //                   />
// //                   <div
// //                     style={{
// //                       flex: 1,
// //                       minWidth: "200px",
// //                       display: "flex",
// //                       flexDirection: "column",
// //                       gap: "5px",
// //                     }}
// //                   >
// //                     <span
// //                       style={{
// //                         fontSize: "14px",
// //                         fontWeight: "bold",
// //                         whiteSpace: "nowrap",
// //                         overflow: "hidden",
// //                         textOverflow: "ellipsis",
// //                         maxWidth: "200px",
// //                       }}
// //                     >
// //                       Order ID: {order.order_id}
// //                     </span>
// //                     <p style={{ fontSize: "12px", color: "#80869A" }}>{order.created_at}</p>
// //                     <p style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
// //                       ₹{order.total_price}
// //                     </p>
// //                   </div>
// //                   <span
// //                     style={{
// //                       padding: "5px 10px",
// //                       borderRadius: "8px",
// //                       backgroundColor: color + "33", // light background
// //                       color: color,
// //                       fontWeight: "600",
// //                       fontSize: "12px",
// //                       flexShrink: 0,
// //                     }}
// //                   >
// //                     {statusText}
// //                   </span>
// //                 </motion.div>
// //               );
// //             })}
// //           </AnimatePresence>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default OrderHistory;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import { motion, AnimatePresence } from "framer-motion";
// import logo from "../../Frozenwala.png";
// import axios from "axios";

// const OrderHistory = () => {
//   const navigate = useNavigate();
//   const [historyData, setHistoryData] = useState([]);
//   const [loadingCancel, setLoadingCancel] = useState(null); // Track which order is being cancelled

//   const getHistory = async () => {
//     try {
//       const uid = localStorage.getItem("user_id");
//       const response = await Api.get(`api/orders/?user_id=${uid}`);
//       console.log("response from order history: ", response.data);
//       setHistoryData(response.data);
//     } catch (error) {
//       console.log("Error fetching history:", error);
//     }
//   };

//   useEffect(() => {
//     getHistory();
//   }, []);

//   const handleButton = (order) => {
//     const { order_id } = order;
//     navigate(`/orderdetails/${order_id}/`);
//   };

// const handleCancelOrder = async (event, order) => {
//   event.stopPropagation();

//   const confirmCancel = window.confirm(`Are you sure you want to cancel order ${order.order_id}?`);

//   if (!confirmCancel) return;

//   try {
//     setLoadingCancel(order.id);

//     // Get the token from localStorage
//     const token = localStorage.getItem("access_token");

//     // Create FormData object (matching the curl example)
//     const formData = new FormData();
//     formData.append('cancel_reason', 'Customer requested cancellation');
//     formData.append('order_id', order.order_id);

//     // Using FormData instead of JSON (matching the curl format)
//     const response = await axios.post(
//       'https://backend.frozenwala.com/api/cancel_order/',
//       formData,
//       {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data', // Explicitly set form-data content type
//         }
//       }
//     );

//     if (response.status === 200 || response.status === 201) {
//       await getHistory(); // Refresh order history
//       alert("Order cancelled successfully!");
//     } else {
//       alert("Failed to cancel order. Please try again.");
//     }
//   } catch (error) {
//     console.error("Error cancelling order:", error);

//     // More detailed error handling
//     if (error.response) {
//       console.error("Error response:", error.response.data);
//       if (error.response.data?.error) {
//         alert(`Cancellation failed: ${error.response.data.error}`);
//       } else {
//         alert("Error cancelling order. Please try again.");
//       }
//     } else {
//       alert("Network error. Please check your connection.");
//     }
//   } finally {
//     setLoadingCancel(null);
//   }
// };

//   const getStatusDetails = (status) => {
//     switch (status) {
//       case "1":
//         return { text: "Pending", color: "#e41f26", code: 1 };
//       case "2":
//         return { text: "Confirm", color: "#03A9F4", code: 2 };
//       case "3":
//         return { text: "Picked Up", color: "#4CAF50", code: 3 };
//       case "4":
//         return { text: "Delivered", color: "#8BC34A", code: 4 };
//       case "5":
//         return { text: "Cancel", color: "#5dc5fa", code: 5 };
//       case "6":
//         return { text: "Return Request", color: "#9E9E9E", code: 6 };
//       case "7":
//         return { text: "Return Accepted", color: "#e41f26", code: 7 };
//       case "8":
//         return { text: "Dispatched", color: "#2196F3", code: 8 };
//       default:
//         return { text: "Unknown", color: "#9C27B0", code: 0 };
//     }
//   };

//   const canCancelOrder = (status) => {
//     const statusCode = parseInt(status);
//     return statusCode === 1 || statusCode === 2;
//   };

//   return (
//     <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh", padding: "20px" }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           marginBottom: "20px",
//         }}
//       >
//         <h1 style={{ flex: 1, textAlign: "center", fontSize: "1.5rem", margin: "10px 0" }}>
//           Order History
//         </h1>
//         <div style={{ width: "100px" }}></div>
//       </div>

//       {historyData.length === 0 ? (
//         <div
//           style={{
//             textAlign: "center",
//             marginTop: "50px",
//             fontSize: "1.2rem",
//             color: "#888",
//           }}
//         >
//           No history available
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "15px",
//             maxWidth: "800px",
//             margin: "0 auto",
//           }}
//         >
//           <AnimatePresence>
//             {historyData.map((order) => {
//               const { text: statusText, color } = getStatusDetails(order.status);
//               const showCancelButton = canCancelOrder(order.status);
//               const isCancelling = loadingCancel === order.id;

//               return (
//                 <motion.div
//                   key={order.id}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -20 }}
//                   whileHover={{ scale: 1.02, boxShadow: "0 8px 20px rgba(0,0,0,0.2)" }}
//                   transition={{ duration: 0.3 }}
//                   onClick={() => handleButton(order)}
//                   style={{
//                     backgroundColor: "#fff",
//                     borderRadius: "12px",
//                     padding: "15px",
//                     display: "flex",
//                     flexWrap: "wrap",
//                     alignItems: "center",
//                     cursor: "pointer",
//                     position: "relative",
//                   }}
//                 >
//                   <img
//                     src={logo}
//                     alt="logo"
//                     style={{
//                       width: "80px",
//                       height: "80px",
//                       borderRadius: "12px",
//                       objectFit: "contain",
//                       marginRight: "15px",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <div
//                     style={{
//                       flex: 1,
//                       minWidth: "200px",
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "5px",
//                     }}
//                   >
//                     <span
//                       style={{
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         maxWidth: "200px",
//                       }}
//                     >
//                       Order ID: {order.order_id}
//                     </span>
//                     <p style={{ fontSize: "12px", color: "#80869A" }}>{order.created_at}</p>
//                     <p style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
//                       ₹{order.total_price}
//                     </p>
//                   </div>
//                   <div style={{ display: "flex", gap: "10px", alignItems: "center", flexShrink: 0 }}>
//                     <span
//                       style={{
//                         padding: "5px 10px",
//                         borderRadius: "8px",
//                         backgroundColor: color + "33",
//                         color: color,
//                         fontWeight: "600",
//                         fontSize: "12px",
//                       }}
//                     >
//                       {statusText}
//                     </span>

//                     {showCancelButton && (
//                       <button
//                         onClick={(e) => handleCancelOrder(e, order)}
//                         disabled={isCancelling}
//                         style={{
//                           padding: "5px 12px",
//                           borderRadius: "8px",
//                           backgroundColor: isCancelling ? "#ccc" : "#5dc5fa",
//                           color: "white",
//                           border: "none",
//                           cursor: isCancelling ? "not-allowed" : "pointer",
//                           fontWeight: "600",
//                           fontSize: "12px",
//                           transition: "all 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           if (!isCancelling) {
//                             e.target.style.backgroundColor = "#5dc5fa";
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (!isCancelling) {
//                             e.target.style.backgroundColor = "#5dc5fa";
//                           }
//                         }}
//                       >
//                         {isCancelling ? "Cancelling..." : "Cancel"}
//                       </button>
//                     )}
//                   </div>
//                 </motion.div>
//               );
//             })}
//           </AnimatePresence>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderHistory;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import { motion, AnimatePresence } from "framer-motion";
// import logo from "../../Frozenwala.png";
// import axios from "axios";

// const OrderHistory = () => {
//   const navigate = useNavigate();
//   const [historyData, setHistoryData] = useState([]);
//   const [loadingCancel, setLoadingCancel] = useState(null);

//   const getHistory = async () => {
//     try {
//       const uid = localStorage.getItem("user_id");
//       const response = await Api.get(`api/orders/?user_id=${uid}`);
//       console.log("response from order history: ", response.data);
//       setHistoryData(response.data);
//     } catch (error) {
//       console.log("Error fetching history:", error);
//     }
//   };

//   useEffect(() => {
//     getHistory();
//   }, []);

//   const handleButton = (order) => {
//     const { order_id } = order;
//     navigate(`/orderdetails/${order_id}/`);
//   };

//   const handleCancelOrder = async (event, order) => {
//     event.stopPropagation();

//     const confirmCancel = window.confirm(
//       `Are you sure you want to cancel order ${order.id}?`,
//     );

//     if (!confirmCancel) return;

//     try {
//       setLoadingCancel(order.id);
//       const token = localStorage.getItem("access_token");
//       const formData = new FormData();
//       formData.append("cancel_reason", "Customer requested cancellation");
//       formData.append("order_id", order.order_id);

//       const response = await axios.post(
//         "https://backend.frozenwala.com/api/cancel_order/",
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       if (response.status === 200 || response.status === 201) {
//         await getHistory();
//         alert("Order cancelled successfully!");
//       } else {
//         alert("Failed to cancel order. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error cancelling order:", error);
//       if (error.response) {
//         console.error("Error response:", error.response.data);
//         if (error.response.data?.error) {
//           alert(`Cancellation failed: ${error.response.data.error}`);
//         } else {
//           alert("Error cancelling order. Please try again.");
//         }
//       } else {
//         alert("Network error. Please check your connection.");
//       }
//     } finally {
//       setLoadingCancel(null);
//     }
//   };

//   const getStatusDetails = (status) => {
//     switch (status) {
//       case "1":
//         return { text: "Pending", color: "#e41f26", bg: "#FFF3E0", code: 1 };
//       case "2":
//         return { text: "Confirmed", color: "#03A9F4", bg: "#E3F2FD", code: 2 };
//       case "3":
//         return { text: "Picked Up", color: "#4CAF50", bg: "#E8F5E9", code: 3 };
//       case "4":
//         return { text: "Delivered", color: "#8BC34A", bg: "#F1F8E9", code: 4 };
//       case "5":
//         return { text: "Cancelled", color: "#5dc5fa", bg: "#FFEBEE", code: 5 };
//       case "6":
//         return {
//           text: "Return Request",
//           color: "#9E9E9E",
//           bg: "#F5F5F5",
//           code: 6,
//         };
//       case "7":
//         return {
//           text: "Return Accepted",
//           color: "#e41f26",
//           bg: "#FFF3E0",
//           code: 7,
//         };
//       case "8":
//         return { text: "Dispatched", color: "#2196F3", bg: "#E3F2FD", code: 8 };
//       default:
//         return { text: "Unknown", color: "#9C27B0", bg: "#F3E5F5", code: 0 };
//     }
//   };

//   const canCancelOrder = (status) => {
//     const statusCode = parseInt(status);
//     return statusCode === 1 || statusCode === 2;
//   };

//   const getRefundInfo = (order) => {
//     if (
//       order.status === "5" &&
//       order.refund_status === "Processed" &&
//       order.refund_amount
//     ) {
//       return {
//         show: true,
//         status: "Processed",
//         amount: order.refund_amount,
//         refundId: order.refund_id,
//         refundedAt: order.refunded_at,
//         icon: "✅",
//         color: "#4CAF50",
//         bg: "#E8F5E9",
//         border: "#4CAF50",
//       };
//     } else if (order.status === "5" && order.refund_status === "Pending") {
//       return {
//         show: true,
//         status: "Pending",
//         amount: order.total_price,
//         icon: "⏳",
//         color: "#e41f26",
//         bg: "#FFF3E0",
//         border: "#e41f26",
//       };
//     } else if (order.status === "5" && order.refund_status === "Failed") {
//       return {
//         show: true,
//         status: "Failed",
//         amount: null,
//         icon: "❌",
//         color: "#5dc5fa",
//         bg: "#FFEBEE",
//         border: "#5dc5fa",
//       };
//     }
//     return { show: false };
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: "#f5f5f5",
//         minHeight: "100vh",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           marginBottom: "20px",
//         }}
//       >
//         <h1
//           style={{
//             flex: 1,
//             textAlign: "center",
//             fontSize: "1.8rem",
//             margin: "10px 0",
//             color: "#333",
//           }}
//         >
//           📋 Order History
//         </h1>
//         <div style={{ width: "100px" }}></div>
//       </div>

//       {historyData.length === 0 ? (
//         <div
//           style={{
//             textAlign: "center",
//             marginTop: "50px",
//             fontSize: "1.2rem",
//             color: "#888",
//           }}
//         >
//           No history available
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "15px",
//             maxWidth: "800px",
//             margin: "0 auto",
//           }}
//         >
//           <AnimatePresence>
//             {historyData.map((order) => {
//               const {
//                 text: statusText,
//                 color,
//                 bg,
//               } = getStatusDetails(order.status);
//               const showCancelButton = canCancelOrder(order.status);
//               const isCancelling = loadingCancel === order.id;
//               const refundInfo = getRefundInfo(order);

//               return (
//                 <motion.div
//                   key={order.id}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -20 }}
//                   whileHover={{
//                     scale: 1.02,
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//                   }}
//                   transition={{ duration: 0.3 }}
//                   onClick={() => handleButton(order)}
//                   style={{
//                     backgroundColor: "#fff",
//                     borderRadius: "16px",
//                     padding: "18px",
//                     display: "flex",
//                     flexDirection: "column",
//                     cursor: "pointer",
//                     position: "relative",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//                   }}
//                 >
//                   {/* Main Row */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <img
//                       src={logo}
//                       alt="logo"
//                       style={{
//                         width: "70px",
//                         height: "70px",
//                         borderRadius: "12px",
//                         objectFit: "contain",
//                         marginRight: "15px",
//                         flexShrink: 0,
//                       }}
//                     />

//                     <div
//                       style={{
//                         flex: 1,
//                         minWidth: "200px",
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: "6px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           fontSize: "14px",
//                           fontWeight: "bold",
//                           color: "#666",
//                           letterSpacing: "0.5px",
//                         }}
//                       >
//                         Order ID:{" "}
//                         <span style={{ color: "#333", fontWeight: "600" }}>
//                           {order.id}
//                         </span>
//                       </span>

//                       <p style={{ fontSize: "12px", color: "#999", margin: 0 }}>
//                         📅 {order.created_at}
//                       </p>

//                       <p
//                         style={{
//                           fontSize: "18px",
//                           fontWeight: "bold",
//                           color: "#333",
//                           margin: 0,
//                         }}
//                       >
//                         ₹{order.total_price?.toFixed(2)}
//                       </p>
//                     </div>

//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         alignItems: "center",
//                         flexShrink: 0,
//                       }}
//                     >
//                       <span
//                         style={{
//                           padding: "6px 14px",
//                           borderRadius: "20px",
//                           backgroundColor: bg,
//                           color: color,
//                           fontWeight: "600",
//                           fontSize: "12px",
//                           border: `1px solid ${color}40`,
//                         }}
//                       >
//                         {statusText}
//                       </span>

//                       {showCancelButton && (
//                         <button
//                           onClick={(e) => handleCancelOrder(e, order)}
//                           disabled={isCancelling}
//                           style={{
//                             padding: "6px 16px",
//                             borderRadius: "20px",
//                             backgroundColor: isCancelling ? "#ccc" : "#5dc5fa",
//                             color: "white",
//                             border: "none",
//                             cursor: isCancelling ? "not-allowed" : "pointer",
//                             fontWeight: "600",
//                             fontSize: "12px",
//                             transition: "all 0.3s ease",
//                             boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                           }}
//                           onMouseEnter={(e) => {
//                             if (!isCancelling) {
//                               e.target.style.backgroundColor = "#5dc5fa";
//                               e.target.style.transform = "scale(1.05)";
//                             }
//                           }}
//                           onMouseLeave={(e) => {
//                             if (!isCancelling) {
//                               e.target.style.backgroundColor = "#5dc5fa";
//                               e.target.style.transform = "scale(1)";
//                             }
//                           }}
//                         >
//                           {isCancelling ? "⏳ Cancelling..." : "❌ Cancel"}
//                         </button>
//                       )}
//                     </div>
//                   </div>

//                   {/* Refund Information Card - Only for cancelled orders with refund */}
//                   {refundInfo.show && (
//                     <motion.div
//                       initial={{ opacity: 0, height: 0 }}
//                       animate={{ opacity: 1, height: "auto" }}
//                       transition={{ duration: 0.3 }}
//                       style={{
//                         marginTop: "15px",
//                         padding: "12px 15px",
//                         borderRadius: "12px",
//                         backgroundColor: refundInfo.bg,
//                         borderLeft: `4px solid ${refundInfo.border}`,
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: "8px",
//                       }}
//                     >
//                       {/* Refund Header */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "10px",
//                         }}
//                       >
//                         <span
//                           style={{
//                             fontWeight: "bold",
//                             color: refundInfo.color,
//                             fontSize: "14px",
//                           }}
//                         >
//                           Refund {refundInfo.status}
//                         </span>
//                       </div>

//                       {/* Refund Details Grid */}
//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns:
//                             "repeat(auto-fit, minmax(150px, 1fr))",
//                           gap: "10px",
//                           marginTop: "4px",
//                         }}
//                       >
//                         {refundInfo.amount && (
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "8px",
//                             }}
//                           >
//                             <div>
//                               <div style={{ fontSize: "11px", color: "#666" }}>
//                                 Refund Amount
//                               </div>
//                               <div
//                                 style={{
//                                   fontWeight: "bold",
//                                   fontSize: "16px",
//                                   color: refundInfo.color,
//                                 }}
//                               >
//                                 ₹{refundInfo.amount}
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {refundInfo.refundId && (
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "8px",
//                             }}
//                           >
//                             <div>
//                               <div style={{ fontSize: "11px", color: "#666" }}>
//                                 Refund ID
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: "12px",
//                                   fontWeight: "500",
//                                   color: "#555",
//                                 }}
//                               >
//                                 {refundInfo.refundId}
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {refundInfo.refundedAt && (
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "8px",
//                             }}
//                           >
//                             <div>
//                               <div style={{ fontSize: "11px", color: "#666" }}>
//                                 Processed On
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: "12px",
//                                   fontWeight: "500",
//                                   color: "#555",
//                                 }}
//                               >
//                                 {formatDate(refundInfo.refundedAt)}
//                               </div>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </motion.div>
//                   )}
//                 </motion.div>
//               );
//             })}
//           </AnimatePresence>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderHistory;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../Utills/Api";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../Frozenwala.png";
import axios from "axios";

const OrderHistory = () => {
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);
  const [loadingCancel, setLoadingCancel] = useState(null);

  // Cancel Modal States
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cancellationReasons = [
    "Changed my mind",
    "Order placed by mistake",
    "Delivery time too long",
    "Found better price elsewhere",
    "Payment issue",
    "Product not needed anymore",
    "Shipping address is incorrect",
    "Duplicate order",
    "Other",
  ];

  const getHistory = async () => {
    try {
      const uid = localStorage.getItem("user_id");
      const response = await Api.get(`api/orders/?user_id=${uid}`);
      console.log("response from order history: ", response.data);
      setHistoryData(response.data);
    } catch (error) {
      console.log("Error fetching history:", error);
    }
  };

  useEffect(() => {
    getHistory();
  }, []);

  const handleButton = (order) => {
    const { order_id } = order;
    navigate(`/orderdetails/${order_id}/`);
  };

  // Open cancel modal instead of direct cancellation
  const openCancelModal = (event, order) => {
    event.stopPropagation();
    setSelectedOrder(order);
    setShowCancelModal(true);
    setCancelReason("");
    setOtherReason("");
  };

  // Close modal
  const closeCancelModal = () => {
    setShowCancelModal(false);
    setSelectedOrder(null);
    setCancelReason("");
    setOtherReason("");
    setIsSubmitting(false);
  };

  // Handle cancel order with reason
  const handleCancelOrder = async () => {
    if (!cancelReason) {
      alert("Please select a cancellation reason");
      return;
    }

    if (cancelReason === "Other" && !otherReason.trim()) {
      alert("Please specify your reason for cancellation");
      return;
    }

    const finalReason = cancelReason === "Other" ? otherReason : cancelReason;

    try {
      setIsSubmitting(true);
      setLoadingCancel(selectedOrder.id);

      const token = localStorage.getItem("access_token");
      const formData = new FormData();
      formData.append("cancel_reason", finalReason);
      formData.append("order_id", selectedOrder.order_id);

      const response = await axios.post(
        "https://backend.frozenwala.com/api/cancel_order/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        await getHistory();
        alert("Order cancelled successfully!");
        closeCancelModal();
      } else {
        alert("Failed to cancel order. Please try again.");
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        if (error.response.data?.error) {
          alert(`Cancellation failed: ${error.response.data.error}`);
        } else {
          alert("Error cancelling order. Please try again.");
        }
      } else {
        alert("Network error. Please check your connection.");
      }
    } finally {
      setIsSubmitting(false);
      setLoadingCancel(null);
    }
  };

  const getStatusDetails = (status) => {
    switch (status) {
      case "1":
        return { text: "Pending", color: "#e41f26", bg: "#FFF3E0", code: 1 };
      case "2":
        return { text: "Confirmed", color: "#03A9F4", bg: "#E3F2FD", code: 2 };
      case "3":
        return { text: "Picked Up", color: "#4CAF50", bg: "#E8F5E9", code: 3 };
      case "4":
        return { text: "Delivered", color: "#8BC34A", bg: "#F1F8E9", code: 4 };
      case "5":
        return { text: "Cancelled", color: "#5dc5fa", bg: "#FFEBEE", code: 5 };
      case "6":
        return {
          text: "Return Request",
          color: "#9E9E9E",
          bg: "#F5F5F5",
          code: 6,
        };
      case "7":
        return {
          text: "Return Accepted",
          color: "#e41f26",
          bg: "#FFF3E0",
          code: 7,
        };
      case "8":
        return { text: "Dispatched", color: "#2196F3", bg: "#E3F2FD", code: 8 };
      default:
        return { text: "Unknown", color: "#9C27B0", bg: "#F3E5F5", code: 0 };
    }
  };

  const canCancelOrder = (status) => {
    const statusCode = parseInt(status);
    return statusCode === 1 || statusCode === 2;
  };

  const getRefundInfo = (order) => {
    if (
      order.status === "5" &&
      order.refund_status === "Processed" &&
      order.refund_amount
    ) {
      return {
        show: true,
        status: "Processed",
        amount: order.refund_amount,
        refundId: order.refund_id,
        refundedAt: order.refunded_at,
        icon: "✅",
        color: "#4CAF50",
        bg: "#E8F5E9",
        border: "#4CAF50",
      };
    } else if (order.status === "5" && order.refund_status === "Pending") {
      return {
        show: true,
        status: "Pending",
        amount: order.total_price,
        icon: "⏳",
        color: "#e41f26",
        bg: "#FFF3E0",
        border: "#e41f26",
      };
    } else if (order.status === "5" && order.refund_status === "Failed") {
      return {
        show: true,
        status: "Failed",
        amount: null,
        icon: "❌",
        color: "#5dc5fa",
        bg: "#FFEBEE",
        border: "#5dc5fa",
      };
    }
    return { show: false };
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Cancel Modal Component
  const CancelModal = () => {
    if (!showCancelModal) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
        onClick={closeCancelModal}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            width: "90%",
            maxWidth: "500px",
            maxHeight: "90vh",
            overflowY: "auto",
            animation: "slideUp 0.3s ease",
            boxShadow: "0 20px 35px rgba(0, 0, 0, 0.2)",
            marginTop: "113px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 24px",
              borderBottom: "1px solid #e9ecef",
              background: "#f8f9fa",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#2c3e50",
              }}
            >
              Cancel Order
            </h3>
            <button
              onClick={closeCancelModal}
              style={{
                background: "none",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: "#6c757d",
                transition: "color 0.2s",
                lineHeight: 1,
                padding: 0,
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.target.style.color = "#5dc5fa";
                e.target.style.background = "rgba(220, 53, 69, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#6c757d";
                e.target.style.background = "none";
              }}
            >
              &times;
            </button>
          </div>

          <div style={{ padding: "10px 24px", marginBottom:"35px" }}>
            <div
              style={{
                marginBottom: "20px",
                padding: "12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
              }}
            >
              <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                <strong>Order ID:</strong> {selectedOrder?.id}
              </p>
              <p
                style={{ margin: "8px 0 0 0", fontSize: "14px", color: "#666" }}
              >
                <strong>Total Amount:</strong> ₹
                {selectedOrder?.total_price?.toFixed(2)}
              </p>
            </div>

            <label
              style={{
                display: "block",
                marginBottom: "12px",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Please tell us why you want to cancel this order:
            </label>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              {cancellationReasons.map((reason) => (
                <label
                  key={reason}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor:
                      cancelReason === reason ? "#e3f2fd" : "#f8f9fa",
                    border:
                      cancelReason === reason
                        ? "1px solid #2196F3"
                        : "1px solid #e9ecef",
                    transition: "all 0.2s",
                  }}
                >
                  <input
                    type="radio"
                    name="cancelReason"
                    value={reason}
                    checked={cancelReason === reason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    style={{ cursor: "pointer" }}
                  />
                  <span style={{ fontSize: "14px", color: "#333" }}>
                    {reason}
                  </span>
                </label>
              ))}
            </div>

            {cancelReason === "Other" && (
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                    color: "#555",
                  }}
                >
                  Please specify your reason:
                </label>
                <textarea
                  placeholder="Type your reason here..."
                  value={otherReason}
                  onChange={(e) => setOtherReason(e.target.value)}
                  rows="3"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontFamily: "inherit",
                    resize: "vertical",
                  }}
                  autoFocus
                />
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={closeCancelModal}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  color: "#6c757d",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#e9ecef";
                  e.target.style.borderColor = "#adb5bd";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#f8f9fa";
                  e.target.style.borderColor = "#dee2e6";
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleCancelOrder}
                disabled={isSubmitting}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  background: isSubmitting ? "#ccc" : "#5dc5fa",
                  border: "none",
                  color: "white",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = "#c82333";
                    e.target.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = "#5dc5fa";
                    e.target.style.transform = "scale(1)";
                  }
                }}
              >
                {isSubmitting ? "Processing..." : "Confirm Cancellation"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Add CSS animations
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from {
          transform: translateY(30px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >
        <h1
          style={{
            flex: 1,
            textAlign: "center",
            fontSize: "1.8rem",
            margin: "10px 0",
            color: "#333",
          }}
        >
          📋 Order History
        </h1>
        <div style={{ width: "100px" }}></div>
      </div>

      {historyData.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            fontSize: "1.2rem",
            color: "#888",
          }}
        >
          No history available
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <AnimatePresence>
            {historyData.map((order) => {
              const {
                text: statusText,
                color,
                bg,
              } = getStatusDetails(order.status);
              const showCancelButton = canCancelOrder(order.status);
              const isCancelling = loadingCancel === order.id;
              const refundInfo = getRefundInfo(order);

              return (
                <motion.div
                  key={order.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  whileHover={{
                    scale: 1.02,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                  }}
                  transition={{ duration: 0.3 }}
                  onClick={() => handleButton(order)}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    padding: "18px",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    position: "relative",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  }}
                >
                  {/* Main Row */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "12px",
                        objectFit: "contain",
                        marginRight: "15px",
                        flexShrink: 0,
                      }}
                    />

                    <div
                      style={{
                        flex: 1,
                        minWidth: "200px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#666",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Order ID:{" "}
                        <span style={{ color: "#333", fontWeight: "600" }}>
                          {order.id}
                        </span>
                      </span>

                      <p style={{ fontSize: "12px", color: "#999", margin: 0 }}>
                        📅 {order.created_at}
                      </p>

                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#333",
                          margin: 0,
                        }}
                      >
                        ₹{order.total_price?.toFixed(2)}
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <span
                        style={{
                          padding: "6px 14px",
                          borderRadius: "20px",
                          backgroundColor: bg,
                          color: color,
                          fontWeight: "600",
                          fontSize: "12px",
                          border: `1px solid ${color}40`,
                        }}
                      >
                        {statusText}
                      </span>

                      {showCancelButton && (
                        <button
                          onClick={(e) => openCancelModal(e, order)}
                          disabled={isCancelling}
                          style={{
                            padding: "6px 16px",
                            borderRadius: "20px",
                            backgroundColor: isCancelling ? "#ccc" : "#5dc5fa",
                            color: "white",
                            border: "none",
                            cursor: isCancelling ? "not-allowed" : "pointer",
                            fontWeight: "600",
                            fontSize: "12px",
                            transition: "all 0.3s ease",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                          onMouseEnter={(e) => {
                            if (!isCancelling) {
                              e.target.style.backgroundColor = "#5dc5fa";
                              e.target.style.transform = "scale(1.05)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isCancelling) {
                              e.target.style.backgroundColor = "#5dc5fa";
                              e.target.style.transform = "scale(1)";
                            }
                          }}
                        >
                          {isCancelling ? "⏳ Cancelling..." : "❌ Cancel"}
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Refund Information Card - Only for cancelled orders with refund */}
                  {refundInfo.show && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      transition={{ duration: 0.3 }}
                      style={{
                        marginTop: "15px",
                        padding: "12px 15px",
                        borderRadius: "12px",
                        backgroundColor: refundInfo.bg,
                        borderLeft: `4px solid ${refundInfo.border}`,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {/* Refund Header */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: refundInfo.color,
                            fontSize: "14px",
                          }}
                        >
                          Refund {refundInfo.status}
                        </span>
                      </div>

                      {/* Refund Details Grid */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(150px, 1fr))",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        {refundInfo.amount && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div>
                              <div style={{ fontSize: "11px", color: "#666" }}>
                                Refund Amount
                              </div>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: refundInfo.color,
                                }}
                              >
                                ₹{refundInfo.amount}
                              </div>
                            </div>
                          </div>
                        )}

                        {refundInfo.refundId && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div>
                              <div style={{ fontSize: "11px", color: "#666" }}>
                                Refund ID
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "#555",
                                }}
                              >
                                {refundInfo.refundId}
                              </div>
                            </div>
                          </div>
                        )}

                        {refundInfo.refundedAt && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div>
                              <div style={{ fontSize: "11px", color: "#666" }}>
                                Processed On
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "#555",
                                }}
                              >
                                {formatDate(refundInfo.refundedAt)}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}
                </motion.div>
              );
            })}
          </AnimatePresence>
        </div>
      )}

      {/* Cancel Modal */}
      <CancelModal />
    </div>
  );
};

export default OrderHistory;
